import { render, staticRenderFns } from "./ItemFavoriteList.vue?vue&type=template&id=71dc02c3&scoped=true&"
import script from "./ItemFavoriteList.vue?vue&type=script&lang=ts&"
export * from "./ItemFavoriteList.vue?vue&type=script&lang=ts&"
import style0 from "./ItemFavoriteList.vue?vue&type=style&index=0&id=71dc02c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dc02c3",
  null
  
)

export default component.exports